import React from 'react'

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core'
import { Text } from 'components/Typography/Basic'
import { Check } from '@material-ui/icons'
import styled from '@emotion/styled'

const tableTitles = [
  'Category of Personal Information',
  'Collected',
  'Disclosed for Business Purposes',
  'Sold*'
]
const tableData = [
  {
    title: 'Identifiers',
    content:
      'including relating to data used to identify you, such as full name, email, address, birthdate (month and day), and phone number.',
    sold: 'No Personal Information Sold'
  },
  {
    title: 'Protected Classification Characteristics',
    content: ' including age, gender, and sex.'
  },
  {
    title: 'Commercial Information',
    content:
      'such as account history and products or services purchased, obtained, or considered.'
  },
  {
    title: 'Internet/Network Information',
    content: 'such as device information, logs, IP address, and analytics data.'
  },
  {
    title: 'Geolocation Data',
    content: 'including your general geographic location.'
  },
  {
    title: 'Sensory Information',
    content:
      ' such as photo or avatar, videos, and recordings of phone calls between you and us, where permitted by law.'
  },
  {
    title: 'Other Personal Information',
    content:
      'including communication preferences, customer service and communications history, personal information you permit us to see when interacting with us through social media, and personal information you provide us in relation to a question, request, inquiry, survey, contest or promotion.'
  },
  {
    title: 'Inferences',
    content:
      'including our predictions about your interests and preferences and related Service Profile Information.'
  }
]

const CollectionDisclosureTable = () => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {tableTitles.map((tableTitle, index) => (
              <TableCell scope="col" key={index}>
                <Text
                  fontSize="20px"
                  className="grey_text"
                  align="center"
                  as="h6"
                  fontWeight="900"
                  lineHeight="22px"
                >
                  {tableTitle}
                </Text>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData &&
            tableData.map((data, index) => (
              <TableRow key={index}>
                <TableCell
                  scope="row"
                  style={{
                    width: '50%'
                  }}
                >
                  <Text as="p" fontWeight="400" className="grey_text">
                    <span
                      style={{
                        fontWeight: 700
                      }}
                    >
                      {data?.title}
                    </span>
                    , {data?.content}
                  </Text>
                </TableCell>
                <TableCell scope="row">
                  <CheckIconWrapper>
                    <StyledCheckIcon />
                  </CheckIconWrapper>
                </TableCell>
                <TableCell scope="row">
                  <CheckIconWrapper>
                    <StyledCheckIcon />
                  </CheckIconWrapper>
                </TableCell>
                {data?.sold && (
                  <TableCell
                    scope="row"
                    rowSpan="8"
                    sx={{
                      verticalAlign: 'text-top'
                    }}
                  >
                    <Text as="p" className="grey_text">
                      {data?.sold}
                    </Text>
                  </TableCell>
                )}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CollectionDisclosureTable

const StyledCheckIcon = styled(Check)`
  font-size: 50px !important;
`

const CheckIconWrapper = styled.div`
  width: 20%;
  margin: auto;
`
